export default __webpack_public_path__ + "static/media/cp-logo-white.0dbb2d15.webp";